import { WALKTHROUGHS_ENABLED } from '@/components/walkthrough/walkthrough-availability';

export type FloatingActionPillPlacement = 'floating' | 'thread-sidebar';

type FloatingActionPillStateArgs = {
  placement: FloatingActionPillPlacement;
  hasWalkthroughForRoute: boolean;
  isWalkthroughActive: boolean;
  isFeedbackRoute: boolean;
};

type FloatingActionPillState = {
  helpAction: 'tour' | null;
  showFeedback: boolean;
};

export function getFloatingActionPillState({
  placement,
  hasWalkthroughForRoute,
  isWalkthroughActive,
  isFeedbackRoute,
}: FloatingActionPillStateArgs): FloatingActionPillState {
  const canStartTour =
    WALKTHROUGHS_ENABLED && hasWalkthroughForRoute && !isWalkthroughActive;

  // Feedback is desktop-only, but that gate is CSS (`max-lg:hidden`) rather
  // than state: this runs during SSR, where no viewport is known, and gating
  // here would drop the control from the server markup and insert it after
  // hydration.
  return {
    helpAction: canStartTour ? 'tour' : null,
    showFeedback: placement === 'thread-sidebar' || isFeedbackRoute,
  };
}
